export default "__VITE_ASSET__6p2IxAgx__"